/* eslint-disable react-hooks/exhaustive-deps */
'use client';
import { useState, useEffect } from 'react';

const useDebounce = (searchString, delay, setPage) => {
  const [debouncedValue, setDebouncedValue] = useState(searchString);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchString);
      setPage && setPage(1);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [searchString, delay]);

  return debouncedValue;
};

export default useDebounce;
